
import {VscGithub } from "react-icons/vsc";
import { BsBoxArrowUpRight } from "react-icons/bs";
import { Link } from "react-router-dom";
function ProjectDetail({project}) {
  const{title,img,description,LiveSite,client,id}=project;
  return (
   <div>
     <div className='card shadow-lg p-5 rounded-sm lg:my-8 my-0'  style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} data-aos="zoom-in-up">
      <div className='w-full h-48 overflow-auto touch-auto'>
  <img className='w-full h-auto' src={img} alt="" />
      </div>
      <div>
       <div className="my-2 ">
       <Link to={`/projects/${id}`} className='font-bold text-neutral'>{title}</Link>
   
       </div>
        <Link to={`/projects/${id}`} className=''>{description?.slice(0, 70)}.......</Link>
        <div className='flex justify-between '>
          <div>
            <Link to={`/projects/${id}`} className='text-neutral' >See More....</Link>
          </div>
     <div className=' flex gap-4 p-3 my-3 rounded-md' >
     <a href={client}> <VscGithub className='text-neutral text-2xl'></VscGithub></a>
       <a href={LiveSite}> <BsBoxArrowUpRight className='text-neutral text-2xl'></BsBoxArrowUpRight></a>
     </div>
        </div>
      </div>
    </div>
      <div className='py-10 md:visible invisible'></div>
   </div>
  )
}

export default ProjectDetail
